import React from 'react';
import { ContentCustom } from '../../../components';

export const EsalesSettings = () => {
  return (
    <>
      <ContentCustom>En cours de dévelopement</ContentCustom>
    </>
  );
};

export default EsalesSettings;
